import React, { useEffect, useRef } from "react";

const Carousel = (props) => {
  const listRef = useRef(null);
  const calculateProgress = (e) => {
    let offset = 70;
    let windowProgress = Math.min(
      1,
      Math.max(0, e.clientX - offset) / (window.innerWidth - offset * 2)
    );

    window.requestAnimationFrame(
      () =>
        (listRef.current.style.left =
          "-" +
          windowProgress *
            (listRef.current.scrollWidth - listRef.current.offsetWidth) +
          "px")
    );
  };
  useEffect(() => {
    if (!props.beStill) {
      if ("ontouchstart" in document.documentElement) {
        // touch - enable pan
        if (listRef.current) listRef.current.style.overflow = "auto";
      } else {
        if (listRef.current) listRef.current.style.overflow = "";
        document.body.addEventListener("mousemove", calculateProgress);
        return () => {
          document.body.removeEventListener("mousemove", calculateProgress);
        };
      }
    }
  });
  return (
    <div className="block-carousel" data-be-still={props.beStill}>
      {props.title && (
        <div className="carousel-title">
          <h3 className="h5">
            <b>{props.title}</b>
          </h3>
        </div>
      )}
      <div className="carousel-viewport">
        <ul ref={listRef}>
          {props.children.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Carousel;
